import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import * as ReduxDOMRender from 'redux-stores/ReduxDOMRender';

import EmbeddedAnalyticsDashboardTabState from './EmbeddedAnalyticsDashboardTabState';
import EmbeddedAnalyticsDashboardView from './EmbeddedAnalyticsDashboardView';

export default class EmbeddedAnalyticsDashboardTabView extends BufferTabView<EmbeddedAnalyticsDashboardTabState> {
  static override initClass(): void {
    this.prototype.className = 'buffer-tab buffer-tab--no-padding';
  }

  override render(): this {
    const props = {
      analyticsDashboardLink: this.model.get('analyticsDashboardLink'),
      itemId: this.model.get('itemId'),
    };
    ReduxDOMRender.renderToDOM(<EmbeddedAnalyticsDashboardView {...props} />, this.el);
    return this;
  }

  override remove(): Backbone.View<EmbeddedAnalyticsDashboardTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}
